module.exports = __webpack_public_path__ + "assets/images/img/image11.cf6f6a7845b46ef1e31925a2d9116f40.jpg";